import React from 'react';

import classes from './ProgressBar.module.css';

const progressBar = (props) => {
    let styleClasses = [classes.ProgressBarSection];

    if (props.styleclass !== undefined) {
        const styles = props.styleclass.split(' ');
        for (let style in styles) {
            styleClasses.push(classes[styles[style].trim()]);
        }
    }

    return (
        <div className={styleClasses.join(' ')}>
            <div className={classes.ProgressBarContainer}>
                {/* {props.showProgressText
                    ? <div className={classes.ProgressText}>{props.progressText}</div>
                    : null} */}

                <div className={classes.ProgressBar}>
                    <div className={classes.Progress} style={{ width: props.progress + '%' }}></div>
                </div>
            </div>
            {props.showProgressText
                ? <div className={classes.ProgressValue}><span>{props.progressValue}</span></div>
                : null}
        </div>
    );
}

export default progressBar;
